import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {UpgradeArrowIcon} from '../../icon/svg/upgrade-arrow-icon';

import styles from './upsell-button.module.css';

type Props = {
    onClick: () => void;
    text: string;
};

export function UpsellButton(props: Props) {
    return (
        <button onClick={props.onClick} className={styles['upsell-button']}>
            <span>{props.text}</span>
            <UpgradeArrowIcon wrapWithDiv={false} size={14} />
        </button>
    );
}
